<template>
    <div style="margin-top: 30vh;" class="flex items-center justify-center w-full">
        <div class="text-gray-400 text-center">
            This page is under construction. See the <a class="text-emerald-400 cursor-pointer hover:opacity-70" href="/platform/reference">API Reference page</a>.
        </div>
    </div>
</template>